export const TIPOS_SOCIETARIOS = [
	{ value: "empresario_individual", label: "Empresário Individual" },
	{ value: "ltda", label: "Sociedade Limitada (LTDA)" },
	{ value: "slu", label: "Sociedade Limitada Unipessoal (SLU)" },
	{ value: "sa", label: "Sociedade Anônima (S.A.)" },
	{ value: "cooperativa", label: "Cooperativa" },
	{ value: "outro", label: "Outro" },
];
